import gsap from 'gsap'
import barba from '@barba/core'
import { once } from './once.js'
import { smoothScroller, snapToTop } from './smoothScroller.js'
import { animation } from './animation.js'
import { deleteArticles } from './deleteArticles.js'
import { swiper } from './swiper.js'
import { verification } from './verification.js'
import { setHeaderColour } from './utilities.js'

const initBarba = () => {

	barba.init({
		debug: false,
		schema: {
			prefix: 'data-load',
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		transitions: [{
			name: 'basic-transition',
			once(data) {
				snapToTop()
				document.body.setAttribute('data-once', true)
				setTimeout(() => {
					data.next.container.setAttribute('data-ready', true)
				}, 2400);
			},
			leave(data) {
				const done = this.async()
				setTimeout(function () {
					done()
				}, 800)
				return gsap.to(data.current.container, { duration: 0.3, opacity: 0 })
			},
			after(data) {
				snapToTop()
				document.body.setAttribute('data-once', true)
				setTimeout(() => {
					data.next.container.setAttribute('data-ready', true)
				}, 1000);
				return gsap.from(data.next.container, { duration: 0.3, opacity: 0 })
			}
		}]
	})

	barba.hooks.once((data) => {
		document.documentElement.setAttribute('data-template', data.next.namespace)
		setTimeout(() => {
			animation()
		}, 2400);
		once()
		smoothScroller()
		verification()
		deleteArticles()
		swiper()
		setHeaderColour(data.next.container)
	})

	barba.hooks.enter((data) => {
		setHeaderColour(data.next.container)
	})

	barba.hooks.after((data) => {
		document.documentElement.setAttribute('data-template', data.next.namespace)
		smoothScroller()
		animation()
		deleteArticles()
		swiper()
	})

}

export default initBarba